import { UploadOutlined, InboxOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Button, Upload } from 'antd';
import { useState } from 'react';
import SparkMD5 from "spark-md5";
const { Dragger } = Upload;
const removeArrayItem = function (array = [], prop, propVal) {
    for (let i = 0, len = array.length; i < len; i++) {
        const item = array[i];
        if (item && item.hasOwnProperty(prop) && item[prop] === propVal) {
            array.splice(i, 1);
        }
    }
};
const getValueByProp = function (data, prop, propVal, r = { found: false, result: null }) {
    if (data && data.hasOwnProperty(prop) && data[prop] === propVal) {
        r.found = true;
        r.result = data;
    }
    for (let key in data) {
        if (data[key] && typeof data[key] === "object") {
            const tmp = getValueByProp(data[key], prop, propVal, r);
            if (tmp.found)
                return tmp;
        }
    }
    return r;
};
const getFileMD5 = function (file) {
    return new Promise((resolve, reject) => {
        if (file && file.size < 2 * 1024 * 1024) {
            const fileReader = new FileReader();
            fileReader.readAsBinaryString(file);
            fileReader.onload = e => {
                resolve(SparkMD5.hashBinary(e.target.result));
            };
        }
        const sliceLength = 10;
        const chunkSize = Math.ceil(file.size / sliceLength);
        const fileReader = new FileReader();
        const md5 = new SparkMD5();
        let index = 0;
        const loadFile = () => {
            const slice = file.slice(index, index + chunkSize);
            fileReader.readAsBinaryString(slice);
        };
        loadFile();
        fileReader.onload = e => {
            md5.appendBinary(e.target.result);
            if (index < file.size) {
                index += chunkSize;
                loadFile();
            }
            else {
                resolve(md5.end());
            }
        };
    });
};
const getSignUrl = async function (api, bucket, key) {
    try {
        const result = await fetch(api, {
            method: "POST",
            body: JSON.stringify({ bucketName: bucket, objectKey: key, method: "PUT", headers: { "Content-Type": "multipart/form-data" } }),
        });
        const json = await result.json();
        return json;
    }
    catch (error) {
        console.error(error);
    }
};
const xhrUploadFile = function (uploadUrl, file, headers = [], processFunc, completeFunc, error) {
    const xhr = new XMLHttpRequest();
    xhr.open("put", uploadUrl);
    for (let key in headers) {
        const value = headers[key];
        if (key) {
            xhr.setRequestHeader(key, value);
        }
    }
    xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
            processFunc && processFunc(event.loaded / event.total);
        }
    };
    xhr.onerror = (err) => {
        error && error(err);
    };
    xhr.onload = () => {
        if (xhr.status === 200) {
            completeFunc && completeFunc();
        }
    };
    xhr.send(file);
    return xhr;
};
const uploadFile = async function (url, file, headers = {}) {
    try {
        const reopt = {
            method: "PUT",
            withCredentials: false,
            headers: headers,
            body: file,
        };
        return fetch(url, reopt);
    }
    catch (error) {
        console.error(error);
    }
};
const getFileExtAndName = function (fileName) {
    const index = fileName.lastIndexOf(".");
    const ext = fileName.substr(index + 1);
    const name = fileName.substr(0, index);
    return { fileExt: ext, fileName: name };
};
const ObsUpload = function (uploadProps) {
    const [loading, setLoading] = useState(null);
    const { api, bucket } = uploadProps.obsSetting;
    const { limit, maxSize, beforeUpload, afterUpload, remove, fileList } = uploadProps.uploadSetting;
    const [fileLst, setFileList] = useState(fileList || []);
    const [resultFileList, setResultFileList] = useState(fileList || []);
    const props = {
        beforeUpload() {
            setLoading(true);
            return false;
        },
        async onChange({ file, fileList }) {
            if (file.status == "removed") {
                setFileList([...fileList]);
            }
            if (file.status)
                return false;
            if (beforeUpload && typeof beforeUpload === "function") {
                await beforeUpload(file);
            }
            const { name, uid } = file;
            let { fileName, fileExt } = getFileExtAndName(name);
            const md5 = await getFileMD5(file);
            const rename = fileName + new Date().getTime() + "." + fileExt;
            const { data, success } = await getSignUrl(api, bucket, rename);
            if (!success)
                return false;
            const { result: SignedResult } = data;
            const { SignedUrl: url, ActualSignedRequestHeaders: header } = SignedResult;
            if (limit && fileList.length > limit) {
                message.error("文件上传数量超过限制");
                removeArrayItem(fileList, "uid", uid);
                setFileList(fileList);
                setLoading(false);
                return false;
            }
            else if (maxSize && file.size > maxSize) {
                message.error("文件大小超过限制");
                removeArrayItem(fileList, "uid", uid);
                setFileList(fileList);
                setLoading(false);
                return false;
            }
            xhrUploadFile(url, file, header, function (process) {
                const percent = Number((process * 100).toFixed(1));
                let { found, result: tmpFile } = getValueByProp(fileList, "uid", uid);
                if (found) {
                    tmpFile.percent = percent;
                    tmpFile.status = "uploading";
                }
                setFileList([...fileList]);
            }, async function () {
                resultFileList.push({ fileName: rename, bucket, md5, uid });
                setResultFileList(resultFileList);
                let { found, result: tmpFile } = getValueByProp(fileList, "uid", uid);
                if (found) {
                    tmpFile.percent = 100;
                    tmpFile.status = "done";
                }
                setFileList([...fileList]);
                if (afterUpload && typeof afterUpload === "function") {
                    await afterUpload(file, resultFileList);
                    setLoading(false);
                }
            }, function (error) {
                console.error(error);
            });
        },
        onRemove(file) {
            removeArrayItem(resultFileList, "uid", file.uid);
            if (remove && typeof remove == "function") {
                remove(file, resultFileList);
            }
            return true;
        },
        fileList: fileLst
    };
    const UploadButton = (<div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>{uploadProps.uploadSetting.message}</div>
        </div>);
    props.accept = uploadProps.uploadSetting.accept;
    return (uploadProps.uploadSetting.type === "button" ? <Upload {...props} fileList={fileLst}>
            <Button icon={<UploadOutlined />}>{uploadProps.uploadSetting.message} </Button>
        </Upload> : uploadProps.uploadSetting.type === "image" ? (<Upload name="avatar" listType="picture-card" className="avatar-uploader" {...props}>
                {UploadButton}
            </Upload>) : (<Dragger {...props}>
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">{uploadProps.uploadSetting.message}</p>
        </Dragger>));
};
export default ObsUpload;
